export const EETDAGBOEK_TEXTAREA_MAX = 4000;

export const EETDAGBOEK_TEXT_FIELDS = [
  "dag",
  "ochtend",
  "voormiddag",
  "middag",
  "namiddag",
  "avond",
  "smorgens",
  "smiddags",
  "savonds",
];

export const EETDAGBOEK_FIELD_LABELS = {
  dag: "Dag",
  ochtend: "s'Ochtends",
  voormiddag: "Voormiddag",
  middag: "s'Middags",
  namiddag: "Namiddag",
  avond: "s'Avonds",
  smorgens: "s'Ochtends",
  smiddags: "s'Middags",
  savonds: "s'Avonds",
};

export const clampEetdagboekText = (value) =>
  typeof value === "string" ? value.slice(0, EETDAGBOEK_TEXTAREA_MAX) : value;

export const getExceededEetdagboekField = (formData) => {
  for (const field of EETDAGBOEK_TEXT_FIELDS) {
    const length = String(formData?.[field] ?? "").length;
    if (length > EETDAGBOEK_TEXTAREA_MAX) {
      return { field, length };
    }
  }
  return null;
};

export const isEetdagboekTextField = (name) =>
  EETDAGBOEK_TEXT_FIELDS.includes(name);
